import React, { Component } from 'react'
import { Trans, withTranslation } from 'react-i18next'
import { Link } from 'react-router-dom'
import Consultations from '@services/Consultations'
import Loading from '../../core/components/Loading'
import { DashboardHeader } from '../Admin.Header'
import CompanyForm from './Company.Form'

class CompanySpecialities extends Component {
  companyClient = Consultations.company

  state = {
    specialities: null,
    isFetching: false,
  }

  componentDidMount() {
    this.setState({ isFetching: true })
    this.companyClient
      .show(Number(this.props.match.params.companyId))
      .then((res) => this.setState({ company: res.data, isFetching: false }))
      .catch((err) => {
        this.setState({ company: undefined, isFetching: false })
        window.alert(JSON.stringify(err.message, null, 2))
      })
  }

  render() {
    const { company } = this.state

    return (
      <>
        <DashboardHeader title={company && company.name}>
          <Link className="btn btn-primary" to={'/companies'}>
            <Trans>Volver</Trans>
          </Link>
        </DashboardHeader>
        <Loading isFetching={this.state.isFetching} />
        <div className="container-fluid main-content">
          {company && <CompanyForm initialValues={company} editable={true} />}
        </div>
      </>
    )
  }
}

export default withTranslation()(CompanySpecialities)
